import React, { useState } from 'react';

type Props = {
	contentItem: any;
	viewOnly?: boolean;
	showProgress?: boolean;
};

const SingleContentItem: React.FC<Props> = ({ contentItem, viewOnly = true, showProgress = false }) => {
	const isCourse = contentItem?.type === 'course';
	const isSolutionGroup = contentItem?.type === 'solution';
	const [open, setOpen] = useState(false);

	return (
		<div className='w-full'>
			<div
				className={`flex   rounded-2xl border-2 bg-[#ECEDF5] p-3.5 transition ${isSolutionGroup ? 'flex-col' : 'flex-row '} ${contentItem?.completed && !viewOnly ? 'border-[#C3F0CC]' : 'border-white'}`}
			>
				<div className='flex flex-1 flex-col gap-1.5'>
					<div className='flex flex-row justify-between items-center'>
						<span className='text-sm font-bold text-[#413F5E]'>{contentItem?.title}</span>
						{isSolutionGroup && (
							<button className='text-xs font-semibold text-[#7C7AF2]' onClick={() => setOpen(!open)}>
								{open ? 'Hide' : 'View'} <span className={`inline-block transition-transform duration-300 ${open ? 'rotate-180' : 'rotate-0'}`}>▼</span>
							</button>
						)}
					</div>

					{!!contentItem?.description && !showProgress && <div className='text-xs text-[#413F5E] opacity-90'>{contentItem?.description}</div>}

					{isCourse && !showProgress && contentItem?.currentDay && <div className='text-xs font-semibold text-[#413F5E]'>Current Day – {contentItem.currentDay}</div>}

					{showProgress && isCourse && (
						<div className='flex flex-col gap-1'>
							<HorizontalProgress current={contentItem.currentDay - 1} total={contentItem.totalDays} />
							<span className='text-[11px] font-semibold text-[#413F5E]'>
								Day {contentItem.currentDay} / {contentItem.totalDays}
							</span>
						</div>
					)}

					{showProgress && contentItem?.total && (
						<div className='flex min-w-[40px] flex-col  gap-1.5'>
							<HorizontalProgress current={contentItem.numberOfCompleted} total={contentItem.total} />
							<span className='text-[11px] font-semibold text-[#413F5E]'>
								{contentItem.numberOfCompleted}/{contentItem.total}
							</span>
						</div>
					)}
				</div>
				{contentItem?.completed && (
					<div className='ml-3 flex h-10 w-10 items-center justify-center rounded-full border-2 border-[#C3F0CC] bg-[#C8F9CD] shadow-[0_4px_8px_rgba(185,255,199,0.8)]'>
						<svg className='h-5 w-5 text-[#2E7D32]' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'>
							<polyline points='20 6 9 17 4 12' />
						</svg>
					</div>
				)}
				{isSolutionGroup && (
					<div className={`overflow-hidden transition-all duration-300 ease-in-out ${open ? 'max-h-[500px] opacity-100 mt-2' : 'max-h-0 opacity-0 mt-0'}`}>
						<div className='flex flex-col gap-2 pl-4'>
							{contentItem.items.map((solution: any) => (
								<div key={solution.id} className={`flex items-center justify-between rounded-xl bg-white p-3 border ${solution.completed ? 'border-[#C3F0CC]' : 'border-[#E3E4F0]'}`}>
									<span className='text-sm text-[#413F5E]'>{solution.title}</span>

									{solution.completed && (
										<div className='flex h-6 w-6 items-center justify-center rounded-full bg-[#C8F9CD]'>
											<svg className='h-4 w-4 text-[#2E7D32]' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='3'>
												<polyline points='20 6 9 17 4 12' />
											</svg>
										</div>
									)}
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default SingleContentItem;

const HorizontalProgress = ({ current, total }: any) => {
	const percent = Math.min((current / total) * 100, 100);

	return (
		<div className='h-1.5 w-full overflow-hidden rounded-md bg-[#DADBE8]'>
			<div className='h-full bg-[#7C7AF2]' style={{ width: `${percent}%` }} />
		</div>
	);
};

const VerticalProgress = ({ completed, total }: any) => {
	const percent = Math.min((completed / total) * 100, 100);

	return (
		<div className='flex h-12 w-1.5 items-end rounded-md bg-[#DADBE8]'>
			<div className='w-full bg-[#7C7AF2]' style={{ height: `${percent}%` }} />
		</div>
	);
};
